import { render, staticRenderFns } from "./ModalSdoh.vue?vue&type=template&id=06ec4b98&scoped=true"
import script from "./ModalSdoh.vue?vue&type=script&lang=js"
export * from "./ModalSdoh.vue?vue&type=script&lang=js"
import style0 from "./ModalSdoh.vue?vue&type=style&index=0&id=06ec4b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec4b98",
  null
  
)

export default component.exports